import { useEffect, useRef, useState } from 'react'

export const useDebounce = <T>(value: T, delay = 500): T => {
  const [debouncedValue, setDebouncedValue] = useState(value)
  const isFirstRender = useRef(true)

  useEffect(() => {
    // Пропускаем таймер на первом рендере, чтобы избежать ненужного setState
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }

    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => clearTimeout(handler) // Очищаем таймер при новом изменении value
  }, [value, delay])

  return debouncedValue
}
